var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 11.4996L6.49967 8.99955M8.99967 11.4996C10.1637 11.0568 11.2804 10.4985 12.333 9.83289M8.99967 11.4996V15.6662C8.99967 15.6662 11.5247 15.2079 12.333 13.9996C13.233 12.6496 12.333 9.83289 12.333 9.83289M6.49967 8.99955C6.94313 7.84908 7.50151 6.74627 8.16634 5.70789C9.13733 4.15538 10.4894 2.8771 12.0938 1.99463C13.6983 1.11217 15.5019 0.654865 17.333 0.666222C17.333 2.93289 16.683 6.91622 12.333 9.83289M6.49967 8.99955L2.33301 8.99957C2.33301 8.99957 2.79134 6.47457 3.99967 5.66623C5.34967 4.76623 8.16634 5.66623 8.16634 5.66623M2.74967 12.7496C1.49967 13.7996 1.08301 16.9163 1.08301 16.9163C1.08301 16.9163 4.19967 16.4996 5.24967 15.2496C5.84134 14.5496 5.83301 13.4746 5.17467 12.8246C4.85076 12.5155 4.42409 12.3368 3.97653 12.323C3.52897 12.3091 3.09207 12.4611 2.74967 12.7496Z",
    stroke: "white",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar2);
export default __webpack_public_path__ + "static/media/sidebar-2.6ba7c43eff0343cd8abfed5331ffd3e3.svg";
export { ForwardRef as ReactComponent };